// extracted by mini-css-extract-plugin
module.exports = {"top-menu-dropdown-layout":"TopMenuDropdownLayout_top-menu-dropdown-layout__tBwLZ","title":"TopMenuDropdownLayout_title__6L_DC","content":"TopMenuDropdownLayout_content__s5t0M"};